<div class="messages">
  @for (message of channel?.messages; track message) {
    <div class="message" [ngClass]="getMessageDirection(message)">
      <p>
        {{ message.from.firstName }}: {{ message.body }}<br />
        <span class="time_date">
          {{ message.timestamp * 1000 | date: 'short' }}
        </span>
      </p>
    </div>
  }
</div>
